<template>
  <div>
    <div
      class="rounded box-border pa-4 mb-5"
      :class="{
        'box-border-brandPrimary': hasCelebration,
        'hover-box cursor-pointer': canClickOuterCard,
      }"
      @click="handleOuterCardClick"
    >
      <div>
        <div class="d-flex align-center">
          <Icon icon="mdi-party-popper" color="brandPrimary" class="mr-4" large />
          <Typography variant="subtitle-1">{{
            hasCelebration ? "Celebration" : "Add a celebration"
          }}</Typography>
        </div>
        <v-card
          v-if="hasCelebration"
          outlined
          elevation="0"
          class="pa-4 mt-4 d-flex justify-space-between align-center"
        >
          <div class="d-flex justify-start align-center lottie-container">
            <div v-if="lottie.star" class="lottie-gif-star-effect">
              <LottiePlayer
                animation="stars"
                :height="250"
                :width="250"
                :speed="1.8"
                :loop="false"
              />
            </div>
            <div v-if="gif">
              <v-img :src="gif" max-width="100" contain></v-img>
            </div>
          </div>
          <div class="d-flex align-center">
            <Button icon @click.stop="handleEditClick" class="mx-2"
              ><v-icon color="black">mdi-pencil-outline</v-icon></Button
            >
            <Button icon @click.stop="clearCelebration"
              ><v-icon color="black">mdi-trash-can-outline</v-icon></Button
            >
          </div>
        </v-card>
      </div>
    </div>
    <v-navigation-drawer v-model="drawer" temporary fixed right width="500">
      <CelebrationSelectorDrawer
        v-if="drawer"
        :hasImageSupport="hasImageSupport"
        :autoGifSelector="!hasImageSupport"
        @close="close"
        @select-celebration="handleCelebration"
      />
    </v-navigation-drawer>
    <v-overlay v-if="drawer" />
  </div>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import CelebrationSelectorDrawer from "@/components/recognition/CelebrationSelector/CelebrationSelectorDrawer.vue";
import LottiePlayer from "@/components/LottiePlayer.vue";

export default {
  name: "CelebrationSelector",
  components: {
    CelebrationSelectorDrawer,
    LottiePlayer,
    Icon,
    Typography,
    Button,
  },
  props: {
    reviewPage: {
      type: Boolean,
      default: false,
    },
    gif: {
      type: String,
      default: null,
    },
    hasImageSupport: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      drawer: false,
      lottie: {
        star: false,
      },
    };
  },
  methods: {
    close() {
      this.drawer = false;
    },
    clearCelebration() {
      this.$emit("clear");
    },
    playStarAnimation() {
      this.lottie.star = true;
      setTimeout(() => {
        this.lottie.star = false;
      }, 1000);
    },
    handleCelebration(celebration) {
      this.playStarAnimation();
      if (celebration.type === "gif") {
        this.$emit("select-gif", celebration.url);
        this.drawer = false;
      } else if (celebration.type === "image" && this.hasImageSupport) {
        this.$emit("select-image", {
          url: celebration.url,
          file: celebration.file,
        });
        this.drawer = false;
      }
    },
    handleOuterCardClick() {
      if (!this.canClickOuterCard) return;
      this.drawer = true;
    },
    handleEditClick() {
      this.drawer = true;
    },
  },
  computed: {
    hasCelebration() {
      return !!this.gif;
    },
    canClickOuterCard() {
      return !this.hasCelebration;
    },
  },
};
</script>

<style scoped>
.box-border {
  border: 2px solid lightgray;
}
.box-border-brandPrimary {
  border-color: var(--v-brandPrimary-base);
}

.lottie-container {
  position: relative;
}

.lottie-gif-star-effect {
  position: absolute;
  top: -75px;
  right: -75px;
  pointer-events: none;
}

.hover-box:hover {
  background-color: #eeeeee;
}
</style>
